import { render, staticRenderFns } from "./SampleCalculation.vue?vue&type=template&id=2d8ce2dc&"
import script from "./SampleCalculation.vue?vue&type=script&lang=js&"
export * from "./SampleCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports